import React from 'react';
import { userServices } from '../../APIServices/userServices';

function Sidebar({
  active,
  setActive,
  groups,
  modules,
  counts,
  currentUserData,
}) {
  const activeModuleGroup = modules?.[active]?.group;

  const logoutAdmin = async (e) => {
    e.preventDefault();
    await userServices.logout({});
  };
  return (
    <div className="sidebar-wrapper">
      {/* Mini Sidebar */}
      <div className="mini-sidebar">
        <div className="mini-sidebar-brand">
          <span className="mini-brand-icon">A</span>
        </div>

        <nav className="mini-nav">
          <button
            className={`mini-nav-item ${activeModuleGroup === 'workspace' || activeModuleGroup === 'workspaceMetadata' ? 'active' : ''}`}
            onClick={() => setActive('dashboard')}
            title="Dashboard"
          >
            <i className="ti ti-home" />
          </button>

          <button
            className={`mini-nav-item ${activeModuleGroup === 'users' ? 'active' : ''}`}
            onClick={() => setActive('user')}
            title="Users"
          >
            <i className="ti ti-user-cog" />
          </button>

          <button
            className={`mini-nav-item ${activeModuleGroup === 'subadmins' ? 'active' : ''}`}
            onClick={() => setActive('subadmin')}
            title="Users"
          >
            <i className="ti ti-user-star" />
          </button>

          <button
            className={`mini-nav-item ${activeModuleGroup === 'governance' ? 'active' : ''}`}
            onClick={() => setActive('audit')}
            title="Audit Trail"
          >
            <i className="ti ti-history" />
          </button>

          <button
            className={`mini-nav-item ${activeModuleGroup === 'settings' ? 'active' : ''}`}
            onClick={() => setActive('settings')}
            title="Users"
          >
            <i className="ti ti-user-check" />
          </button>
        </nav>
        <div className="mini-sidebar-footer">
          <button
            className="mini-nav-item logout"
            onClick={logoutAdmin}
            title="Sign Out"
          >
            <i className="ti ti-logout" />
          </button>
        </div>
      </div>

      {/* Main Sidebar */}
      <aside className="sidebar">
        <div className="brand">
          <div className="brand-mark">Admin Panel</div>
          <div className="brand-sub">Manage Users & Metadatas</div>
        </div>

        <nav className="nav">
          {groups.map((group) => (
            <div key={group.id} className="nav-group">
              <div className="nav-group-label">{group.label}</div>

              {Object.entries(modules)
                .filter(([_, module]) => module.group === group.id)
                .map(([key, module]) => (
                  <button
                    key={key}
                    className={`nav-item ${active === key ? 'active' : ''}`}
                    onClick={() => setActive(key)}
                  >
                    <i className={`ti ${module.icon}`} />
                    <span>{module.name}</span>

                    {counts?.[key] > 0 && (
                      <span className="nav-badge">{counts[key]}</span>
                    )}
                  </button>
                ))}
            </div>
          ))}
        </nav>

        <div className="sidebar-foot">
          <div className="user-avatar">
            {currentUserData?.roleType === "admin" ? "A" : "SA"}
          </div>

          <div className="sidebar-user">
            <div className="user-name">
              {[currentUserData?.firstName, currentUserData?.middleName, currentUserData?.lastName]
                .filter(Boolean)
                .join(" ")}
            </div>

            <div className="user-role">
              {currentUserData?.roleType === "admin" ? "Admin" : "Sub Admin"}
            </div>
          </div>
        </div>
      </aside>
    </div>
  );
}

export default Sidebar;
